module.exports = __webpack_public_path__ + "static/media/move-up.3be77715.svg";